import { observer } from 'mobx-react-lite';
import * as R from 'ramda';
import { withDefaultProps } from 'react-default-props-context';
import { AnswerListViewItem } from 'src/answers/components';
import { AnswerT } from 'src/api/types/AnswerT';
import { QuestionT } from 'src/api/types/QuestionT';
import { cn } from 'src/frames/utils/cn';
import './AnswerListView.scss';

type PropsT = {
  className?: any;
};

type DefaultPropsT = {
  questionDisplayNr: number;
  question: QuestionT;
  answerQuestion: (
    question: QuestionT,
    answer: AnswerT,
    questionDisplayNr: number
  ) => void;
  goToNextPage: () => void;
};

export const AnswerListView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    const answers = props.question.answerSet;
    const answerDivs = R.pipe(
      R.always(answers),
      R.map((answer: AnswerT) => {
        return (
          <AnswerListViewItem
            className="my-2"
            key={answer.id}
            answer={answer}
            onClick={() => {
              props.answerQuestion(props.question, answer, props.questionDisplayNr);
              props.goToNextPage();
            }}
          />
        );
      })
    )();

    return (
      <div className={cn('AnswerListView', 'flex flex-col', props.className)}>
        {answerDivs}
      </div>
    );
  })
);
